export const GET_SETTLEMENTS_REQUEST = 'GET_SETTLEMENTS_REQUEST';
export const GET_SETTLEMENTS_FAILURE = 'GET_SETTLEMENTS_FAILURE';
export const GET_SETTLEMENTS_SUCCESS = 'GET_SETTLEMENTS_SUCCESS';
export const SET_XERO_BANK_ACCOUNTS = 'SET_XERO_BANK_ACCOUNTS';
export const START_TRANSACTIONS_SELECTION = 'START_TRANSACTIONS_SELECTION';
export const END_TRANSACTIONS_SELECTION = 'END_TRANSACTIONS_SELECTION';
